module.exports = __webpack_public_path__ + "media/images/front/programs/icon-person-inactive-bb72006b876d605dd82d4fd7f6891e7e.svg";